import Api from './api';

export default {
  unsubscribe: (type, token) => Api.post(`unsubscribe/${type}`, { token }),
};
